import React from "react";
import "../App.css";

const HomeLeadImage = () => {
  return (
    <div>
      <div className="homeImage">
        <div className="content flex">
          <h6>We are Here To Manage your Library</h6>
        </div>
      </div>
    </div>
  );
};

export default HomeLeadImage;
